import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import classNames from 'classnames';
import moment from 'moment-timezone';
import {updateTimes} from 'search-request/search-request-actions';
import AirportDateTimePickers from 'common/airport/AirportDateTimePickers';
import withConfig from 'config/withConfig';

class SearchAirportControls extends Component {
    static propTypes = {
        className: PropTypes.string,
        starts: PropTypes.string,
        ends: PropTypes.string,
        apiDateTimeFormat: PropTypes.string,
        currentCityTimezone: PropTypes.string,
        updateSearchTimes: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        setDefaultSearchTimes: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        const {currentCityTimezone, apiDateTimeFormat} = props;
        const nowTZ = moment().tz(currentCityTimezone);
        const roundMinutes = (60 - nowTZ.minutes()) % 30;

        // Set default start date to today + half hour, rounded up
        // (~50% of users book within an hour of the start time)
        this._defaultStarts = nowTZ
            .clone()
            .add(30 + roundMinutes, 'minutes')
            .format(apiDateTimeFormat);
        // Set default end date to 5 days after, at 11:30pm
        // (the average reservation length is a little over 5 days)
        this._defaultEnds = nowTZ
            .clone()
            .add(5, 'days')
            .hours(23)
            .minutes(30)
            .format(apiDateTimeFormat);
    }

    _onSearchClick = ({starts, ends}) => {
        const {updateSearchTimes, onSubmit} = this.props;

        updateSearchTimes({
            starts,
            ends,
        });

        if (onSubmit) {
            onSubmit();
        }
    };

    render() {
        const {className, starts, ends, setDefaultSearchTimes} = this.props;
        const classes = classNames('SearchAirportControls', className);

        return (
            <div className={classes}>
                <AirportDateTimePickers
                    starts={
                        setDefaultSearchTimes && !starts
                            ? this._defaultStarts
                            : starts
                    }
                    ends={
                        setDefaultSearchTimes && !ends
                            ? this._defaultEnds
                            : ends
                    }
                    onSearchClick={this._onSearchClick}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        searchRequest: {starts, ends},
        city: {
            data: {timezone: currentCityTimezone},
        },
    } = state;

    return {
        starts,
        ends,
        currentCityTimezone,
    };
};

const mapDispatchToProps = {
    updateSearchTimes: updateTimes,
};

const enhance = compose(
    withConfig(['apiDateTimeFormat']),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
);

export default enhance(SearchAirportControls);
